import {
    IntentKind,
    makeIntentBuilderFunction,
    makeIntentGuard,
} from '@jet-app/music-classical/intents';
import type { Intent } from '@jet/environment/dispatching';

export interface UserComponentsIntent extends Intent<any> {
    $kind: IntentKind.USER_COMPONENTS_INTENT;
    url: string;
    actionType?: 'fetch' | 'perform';
    payload?: any;
}

export const isUserComponentsIntent = makeIntentGuard<UserComponentsIntent>(
    IntentKind.USER_COMPONENTS_INTENT,
);

export const makeUserComponentsIntent =
    makeIntentBuilderFunction<UserComponentsIntent>(
        IntentKind.USER_COMPONENTS_INTENT,
    );
